
export const dataAssets = {
    SeriedesTerracota2006: ["Tortue_10_WJPG.jpg", "Tortue_39_WJPG.jpg", "Tortues_29_JPG.jpg",
        "Tortue_17.jpg", "Tortue_46_WJPG.jpg", "Tortues_2_JPG.jpg",
        "Tortue_18_WJPG.jpg", "Tortue_47_WJPG.jpg", "Tortues_2_JPG_(16).jpg",
        "Tortue_19_WJPG.jpg", "Tortue_48_WJPG.jpg", "Tortues_3_JPG.jpg",
        "Tortue_20_WJPG.jpg", "Tortue_49_WJPG.jpg", "Tortues_4_JPG.jpg",
        "Tortue_21_WJPG.jpg", "Tortue_7_WJPG.jpg", "Tortues_51_JPG.jpg",
        "Tortue_22.jpg", "Tortue_8_WJPG.jpg", "Tortues_52_JPG.jpg",
        "Tortue_24_WJPG.jpg", "Tortues_0_JPG.jpg", "Tortues_5_JPG.jpg",
        "Tortue_25_WJPG.jpg", "Tortues_10_JPG.jpg", "Tortues_6_JPG.jpg",
        "Tortue_31_WJPG.jpg", "Tortues_11_JPG.jpg", "Tortues_7_JPG.jpg",
        "Tortue_32_WJPG.jpg", "Tortues_12_JPG.jpg", "Tortues_8_JPG.jpg",
        "Tortue_33_WJPG.jpg", "Tortues_13_JPG.jpg", "Tortues_9_JPG.jpg",
        "Tortue_36_WJPG.jpg", "Tortues_14_JPG.jpg",
        "Tortue_37_WJPG.jpg", "Tortues_15_JPG.jpg"],

    SeriedesImpressionsTissus2009: ["236_Wjpg.jpg",
        "Tortues_178_jpg.jpg",
        "Tortues_100_jpg.jpg",
        "Tortues_179_jpg.jpg",
        "Tortues_102_jpg.jpg",
        "Tortues_180_jpg.jpg",
        "Tortues_109_jpg.jpg",
        "Tortues_181_jpg.jpg",
        "Tortues_110_jpg.jpg",
        "Tortues_183_jpg.jpg",
        "Tortues_111_jpg.jpg",
        "Tortues_184_jpg.jpg",
        "Tortues_112_jpg.jpg", "Tortues_186_jpg.jpg",
        "Tortues_113_jpg.jpg", "Tortues_187_jpg.jpg",
        "Tortues_114_jpg.jpg", "Tortues_188_jpg.jpg",
        "Tortues_115_jpg.jpg", "Tortues_189_jpg.jpg",
        "Tortues_116_jpg.jpg", "Tortues_190_jpg.jpg",
        "Tortues_117_jpg.jpg", "Tortues_192_jpg.jpg",
        "Tortues_118_jpg.jpg", "Tortues_193_jpg.jpg",
        "Tortues_119_jpg.jpg", "Tortues_194_jpg.jpg",
        "Tortues_120_jpg.jpg", "Tortues_195_jpg.jpg",
        "Tortues_121_jpg.jpg", "Tortues_196_jpg.jpg",
        "Tortues_122_jpg.jpg", "Tortues_197_jpg.jpg",
        "Tortues_123_jpg.jpg", "Tortues_198_jpg.jpg",
        "Tortues_124_jpg.jpg", "Tortues_199_jpg.jpg",
        "Tortues_125_jpg.jpg", "Tortues_200_jpg.jpg",
        "Tortues_127_jpg.jpg", "Tortues_201_jpg.jpg",
        "Tortues_128.jpg", "Tortues_202_jpg.jpg",
        "Tortues_128_jpg.jpg", "Tortues_203_jpg.jpg",
        "Tortues_129_jpg.jpg", "Tortues_204_jpg.jpg",
        "Tortues_130.jpg", "Tortues_206.jpg",
        "Tortues_130_jpg.jpg", "Tortues_207.jpg",
        "Tortues_131.jpg", "Tortues_208.jpg",
        "Tortues_131_jpg.jpg", "Tortues_208_(2).jpg",
        "Tortues_132_jpg.jpg", "Tortues_209.jpg",
        "Tortues_133_jpg.jpg", "Tortues_210.jpg",
        "Tortues_134_jpg.jpg", "Tortues_211.jpg",
        "Tortues_135_jpg.jpg", "Tortues_212.jpg",
        "Tortues_136_jpg.jpg", "Tortues_212_(240x300).jpg",
        "Tortues_137_jpg.jpg", "Tortues_212_(516x640).jpg",
        "Tortues_138_jpg.jpg", "Tortues_213.jpg",
        "Tortues_139_jpg.jpg", "Tortues_214.jpg",
        "Tortues_140_jpg.jpg", "Tortues_215.jpg",
        "Tortues_141_jpg.jpg", "Tortues_216.jpg",
        "Tortues_142_jpg.jpg", "Tortues_217.jpg",
        "Tortues_143_jpg.jpg", "Tortues_217_(451x640).jpg",
        "Tortues_144_jpg.jpg", "Tortues_218.jpg",
        "Tortues_145_jpg.jpg", "Tortues_218_(640x523).jpg",
        "Tortues_146_jpg.jpg", "Tortues_220_Wjpg.jpg",
        "Tortues_147_jpg.jpg", "Tortues_221_Wjpg.jpg",
        "Tortues_148_jpg.jpg", "Tortues_222_Wjpg.jpg",
        "Tortues_149_jpg.jpg", "Tortues_223_Wjpg.jpg",
        "Tortues_150_jpg.jpg", "Tortues_226_Wjpg.jpg",
        "Tortues_151_jpg.jpg", "Tortues_231_Wjpg.jpg",
        "Tortues_152_jpg.jpg", "Tortues_235_Wjpg.jpg",
        "Tortues_153_jpg.jpg", "Tortues_237_Wjpg.jpg",
        "Tortues_154_jpg.jpg", "Tortues_238_Wjpg.jpg",
        "Tortues_155_jpg.jpg", "Tortues_239_Wjpg.jpg",
        "Tortues_156_jpg.jpg", "Tortues_240_Wjpg.jpg",
        "Tortues_157_jpg.jpg", "Tortues_241_Wjpg.jpg",
        "Tortues_157_jpg_(449x640).jpg", "Tortues_242_Wjpg.jpg",
        "Tortues_158_jpg.jpg", "Tortues_53.jpg",
        "Tortues_159_jpg.jpg", "Tortues_54.jpg",
        "Tortues_160_jpg.jpg", "Tortues_55.jpg",
        "Tortues_161_jpg.jpg", "Tortues_56.jpg",
        "Tortues_162_jpg.jpg", "Tortues_56_jpg.jpg",
        "Tortues_163_jpg.jpg", "Tortues_57.jpg",
        "Tortues_164_jpg.jpg", "Tortues_58.jpg",
        "Tortues_165_jpg.jpg", "Tortues_59.jpg",
        "Tortues_166_jpg.jpg", "Tortues_60_jpg.jpg",
        "Tortues_167_jpg.jpg", "Tortues_62.jpg",
        "Tortues_168_jpg.jpg", "Tortues_63.jpg",
        "Tortues_169_jpg.jpg", "Tortues_64_jpg.jpg",
        "Tortues_170_jpg.jpg", "Tortues_65.jpg",
        "Tortues_171_jpg.jpg", "Tortues_65_jpg.jpg",
        "Tortues_172_jpg.jpg", "Tortues_66.jpg",
        "Tortues_174_jpg.jpg", "Tortues_66_jpg.jpg",
        "Tortues_176_jpg.jpg", "tortues_61.jpg",
        "Tortues_177.jpg"],

    SeriedesPapiersChinois2011: [
         'Tortues_219.jpg',
         'Turtles_208_Shangai_jpg.jpg',
        "Tortues_219_OK.jpg",
        "Tortues_219_WJPG.jpg"
    ],
Venus:[
    "Nu _64_WJPG.jpg",
    "Nu_149_WJPG.jpg",
    "Nu_150_WJPG.jpg",
    "Nu_154_WJPG.jpg",
    "Nu_155_WJPG.jpg",
    "Nu_157_WJPG.jpg",
    "Nu_159_WJPG.jpg",
    "Nu_160_WJPG.jpg",
    "Nu_168_WJPG.jpg",
    "Nu_169_WJPG.jpg",
    "Nu_175.jpg",
    "Nu_176.jpg",
    "Nu_177.jpg",
    "Nu_178.jpg",
    "Nu_179_WJPG.jpg",
    "Nu_184_WJPG.jpg",
    "Nu_187_WJPG.jpg",
    "Nu_67_WJPG.jpg",
    "Nu_71_WJPG.jpg",
    "Nu_96_JPG.jpg",
    "Nu_97_WJPG.jpg"
], 

    Photosautravail2010: [
        'Atelier_10_WJPG.jpg', 'Atelier_23_WJPG.jpg',
        'Atelier_11_WJPG.jpg', 'Atelier_24_WJPG.jpg',
        'Atelier_12_WJPG.jpg', 'Atelier_25_WJPG.jpg',
        'Atelier_13_WJPG.jpg', 'Atelier_26_WJPG.jpg',
        'Atelier_14_WJPG.jpg', 'Atelier_27_WJPG.jpg',
        'Atelier_2_WJPG.jpg',
        'Atelier_15_WJPG.jpg', 'Atelier_3_WJPG.jpg',
        'Atelier_16_WJPG.jpg', 'Atelier_4_WJPG.jpg',
        'Atelier_17_WJPG.jpg', 'Atelier_5_WJPG.jpg',
        'Atelier_18_WJPG.jpg', 'Atelier_6.jpg',
        'Atelier_19_WJPG.jpg', 'Atelier_7_WJPG.jpg',
        'Atelier_1_WJPG.jpg', 'Atelier_8_WJPG.jpg',
        'Atelier_20_WJPG.jpg', 'Atelier_9_WJPG.jpg',
        'Atelier_21_WJPG.jpg',
        'Atelier_22_WJPG.jpg'

    ]



}









	



